import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./api";

export const notificationAPI = createApi({
  reducerPath: "notificationAPI",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["refetchNotification"],
  endpoints: (builder) => ({
    getNotificationAPI: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/notifications`,
        method: "GET",
        params: { page, limit: 6 },
      }),

      providesTags: ["refetchNotification"],
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      // Always merge incoming data to the cache entry
      merge: (currentCache, newItems) => {
        currentCache.results.push(...newItems.results);
      },
      // Refetch when the page arg changes
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),

    updateNotification: builder.mutation({
      query: (id) => ({
        url: `/notifications/${id}`,
        method: "PATCH",
      }),
    }),
  }),
});

export const { useGetNotificationAPIQuery, useUpdateNotificationMutation } =
  notificationAPI;
